import React, { useState } from 'react';
import MatchListSelector from '../../match-list-selector';
import { MatchListCommon } from '../../utils/match-list-models';
import { MatchListItemLayout } from '../../utils/match-list.constants';
import MatchOfTheDayMatchList, { MatchOfTheDayMatchListPublicProps } from './match-of-the-day-match-list';
import { PlatformTypes } from '@om-fe/utils';

export interface MatchOfTheDayMatchListSelectorPublicProps extends MatchListCommon {
    readonly instanceId: string;
    readonly disciplineId: string;
    readonly itemLayout?: MatchListItemLayout;
    readonly marketGroupsOverviewNumber?: number;
    readonly hasMarketSelector: boolean;
    readonly deviceType?: PlatformTypes;
    readonly showMarketSelectorHeader?: boolean;
    readonly locationId?: string;
    readonly eventCategoryId?: string;
    readonly preventRedirect?: boolean;
    readonly noRedirectFilter?: (genericId?: string) => void;
    readonly genericId?: string;
    readonly dateRange: string;
}

type MatchOfTheDayMatchListSelectorProps = MatchOfTheDayMatchListSelectorPublicProps
    & MatchOfTheDayMatchListPublicProps;

const MatchOfTheDayMarketGroups: React.FC<MatchOfTheDayMatchListSelectorProps> = (
    {
        instanceId,
        disciplineId,
        liveStatus,
        limitNumberOfEvents,
        mainMarketsLimit,
        marketsHeaderOptions,
        hasMarketSelector,
        deviceType,
        itemLayout,
        showMarketSelectorHeader,
        locationId,
        eventCategoryId,
        preventRedirect,
        noRedirectFilter,
        genericId,
        dateRange,
        filteredMarketGroupsOverviewList,
        filteredMarketGroupsOverview,
        groupOverview,
    }: MatchOfTheDayMatchListSelectorProps,
) => {
    const [matchOfTheDayGroupOverview, setMatchOfTheDayGroupOverview] = useState<string | undefined>(groupOverview);

    const selectMatchOfTheDayGroupsOverview = (item: string) => {
        const listSelected = mainMarketsLimit === 1
            ? item
            : filteredMarketGroupsOverviewList?.slice(0, mainMarketsLimit - 1)
                .concat(item)
                .join(',');
        setMatchOfTheDayGroupOverview(listSelected);
    };

    if (showMarketSelectorHeader && filteredMarketGroupsOverviewList?.length) {
        return <MatchOfTheDayMatchList
            disciplineId={disciplineId}
            instanceId={instanceId}
            liveStatus={liveStatus}
            limitNumberOfEvents={limitNumberOfEvents}
            marketsHeaderOptions={marketsHeaderOptions}
            mainMarketsLimit={mainMarketsLimit}
            groupOverview={matchOfTheDayGroupOverview}
            hasMarketSelector={filteredMarketGroupsOverviewList?.length ? hasMarketSelector : false}
            itemLayout={itemLayout}
            selectGroupsOverview={selectMatchOfTheDayGroupsOverview}
            filteredMarketGroupsOverview={filteredMarketGroupsOverview}
            filteredMarketGroupsOverviewList={filteredMarketGroupsOverviewList}
            isHasDrawer={true}
            deviceType={deviceType}
            locationId={locationId}
            eventCategoryId={eventCategoryId}
            preventRedirect={preventRedirect}
            noRedirectFilter={noRedirectFilter}
            genericId={genericId}
            dateRange={dateRange} 
            limit={limitNumberOfEvents!}
        />;
    }

    return (
        <>
            {!!filteredMarketGroupsOverviewList?.length && (
                <MatchListSelector
                    selectGroupsOverview={selectMatchOfTheDayGroupsOverview}
                    filteredMarketGroupsOverview={filteredMarketGroupsOverview}
                    filteredMarketGroupsOverviewList={filteredMarketGroupsOverviewList}
                    marketSelected={matchOfTheDayGroupOverview!}
                    mainMarketsLimit={mainMarketsLimit}
                    isHasDrawer={true}
                    deviceType={deviceType}
                />
            )
            }
            <MatchOfTheDayMatchList
                disciplineId={disciplineId}
                instanceId={instanceId}
                liveStatus={liveStatus}
                limitNumberOfEvents={limitNumberOfEvents}
                marketsHeaderOptions={marketsHeaderOptions}
                mainMarketsLimit={mainMarketsLimit}
                groupOverview={matchOfTheDayGroupOverview!}
                hasMarketSelector={filteredMarketGroupsOverviewList?.length ? hasMarketSelector : false}
                itemLayout={itemLayout}
                locationId={locationId}
                eventCategoryId={eventCategoryId}
                preventRedirect={preventRedirect}
                noRedirectFilter={noRedirectFilter}
                genericId={genericId}
                dateRange={dateRange}
                limit={limitNumberOfEvents!}
            />
        </>
    );
};

export default MatchOfTheDayMarketGroups;
